// extracted by mini-css-extract-plugin
export default {"header":"ElevatedStorageReservoir_header__9DScl","content":"ElevatedStorageReservoir_content__-m6GV","divider":"ElevatedStorageReservoir_divider__GIQwc"};